// Counter
$.fn.jQuerySimpleCounter = function( options ) {
    var settings = $.extend({
        start:  0,
        end:    100,
        easing: 'swing',
        duration: 400,
        complete: ''
    }, options );

    var thisElement = $(this);

    $({count: settings.start}).animate({count: settings.end}, {
        duration: settings.duration,
        easing: settings.easing,
        step: function() {
            var mathCount = Math.ceil(this.count);
            thisElement.text(mathCount);
        },
        complete: settings.complete
    });
};

//

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
} 

//

$("#carousel").owlCarousel({
  loop: false,
  margin: 0,
  autoWidth: false,
  autoplay: false,
  nav: true,
  dots: false,
  center: false,
  responsiveClass: true,
  responsive: {
    0: {
      items: 2
    },
    600: {
      items: 3
    },
    768: {
      items: 4
    },
    1024: {
      items: 6
    },
    1200: {
      items: 8
    }
  }
});
